module.exports = __webpack_public_path__ + "static/media/construction-profile.000b79dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/construction-profile.jpg
// module id = 381
// module chunks = 0